<style lang="less" scoped>
.assign-list{
  width: 100%;
  overflow: auto;
}
</style>

<template>
  <div class="assign-list" :style="{ height: height ? height + 'px' : 'auto' }" >
    <a-table :dataSource="data" :columns="columns" bordered :pagination="false" :scroll="{ x: 880 }" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { TableColumnType } from 'ant-design-vue'
import overdueApi from '../../api/overdue'

export default defineComponent({
  name: 'AssignList',
  props: {
    id: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      data: [] as any[],
      columns: [
        {
          dataIndex: 'contractNumber',
          title: '合同号',
          align: 'center'
        },
        {
          dataIndex: 'assignPersonName',
          title: '分派人员',
          align: 'center'
        },
        {
          dataIndex: 'assignType',
          title: '分派类型',
          align: 'center',
          customRender({ text }) {
            return text === '1' ? '电催' : '上门'
          },
        },
        {
          dataIndex: 'createdTime',
          title: '分派时间',
          align: 'center'
        },
        {
          dataIndex: 'createdName',
          title: '分派操作员',
          align: 'center'
        },
      ] as TableColumnType[]
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData()
        }
      }
    }
  },
  methods: {
    getData() {
      this.data = []
      overdueApi.overdueAssignList.require({
        overdueRecordId: this.id,
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        this.data = res.data.data
      })
    }
  }
})
</script>
